/**
 * 路由 → moduleId 映射表（应用侧注入，供 prome-core 使用）
 *
 * 规则：moduleId 取浏览器完整 pathname（含 qiankun 子应用 base `/smart`），与 window.location.pathname 一致。
 */
import type { ModuleMeta } from '@/core/runtime';

export const MODULE_MAP: Record<string, ModuleMeta> = {
  // 活动模块
  '/smart/activity/list': { moduleId: '/smart/activity/list', pageTitle: '我的活动' },
  '/smart/activity/flow': { moduleId: '/smart/activity/flow', pageTitle: '活动编辑' },
  '/smart/activity/detail': { moduleId: '/smart/activity/detail', pageTitle: '活动详情' },
  '/smart/activity/doc': { moduleId: '/smart/activity/doc', pageTitle: '活动文档' },
  '/smart/activity/service_doc': { moduleId: '/smart/activity/service_doc', pageTitle: '服务类型文档' },
  '/smart/activity/test_doc': { moduleId: '/smart/activity/test_doc', pageTitle: '测试工具文档' },

  // 报表模块
  '/smart/report/config': { moduleId: '/smart/report/config', pageTitle: '活动指标配置' },
  '/smart/report/detail': { moduleId: '/smart/report/detail', pageTitle: '活动指标详情' },

  // 运营报表
  '/smart/operateReport': { moduleId: '/smart/operateReport', pageTitle: '运营报表' },

  // 智能运营首页
  '/smart/op/home': { moduleId: '/smart/op/home', pageTitle: '智能运营首页' },

  // 管理模块
  '/smart/manage/template/list': { moduleId: '/smart/manage/template/list', pageTitle: '模板管理' },
  '/smart/manage/template/new': { moduleId: '/smart/manage/template/new', pageTitle: '模板编辑' },
  '/smart/manage/interface/list': { moduleId: '/smart/manage/interface/list', pageTitle: '接口管理' },
  '/smart/manage/interface/new': { moduleId: '/smart/manage/interface/new', pageTitle: '接口编辑' },
  '/smart/manage/roster': { moduleId: '/smart/manage/roster', pageTitle: '特殊名单' },
  '/smart/manage/crowd/list': { moduleId: '/smart/manage/crowd/list', pageTitle: '人群管理' },
  '/smart/manage/crowd/new': { moduleId: '/smart/manage/crowd/new', pageTitle: '人群编辑' },
  '/smart/manage/trigger/list': { moduleId: '/smart/manage/trigger/list', pageTitle: '事件管理' },
  '/smart/manage/trigger/new': { moduleId: '/smart/manage/trigger/new', pageTitle: '事件编辑' },
  '/smart/manage/cd/list': { moduleId: '/smart/manage/cd/list', pageTitle: '端外推送设置' },
  '/smart/manage/message/list': { moduleId: '/smart/manage/message/list', pageTitle: '推送模板' },
  '/smart/manage/message/new': { moduleId: '/smart/manage/message/new', pageTitle: '推送模板编辑' },
  '/smart/manage/questionnaire/list': { moduleId: '/smart/manage/questionnaire/list', pageTitle: '问卷管理' },
  '/smart/manage/questionnaire/edit': { moduleId: '/smart/manage/questionnaire/edit', pageTitle: '问卷编辑' },

  // 小组件
  '/smart/widget/home': { moduleId: '/smart/widget/home', pageTitle: 'Widget 首页' },
  '/smart/widget/case': { moduleId: '/smart/widget/case', pageTitle: 'Widget 案例' },
  '/smart/widget/operateReport': { moduleId: '/smart/widget/operateReport', pageTitle: 'Widget 运营报表' },
  '/smart/widget/feedBack': { moduleId: '/smart/widget/feedBack', pageTitle: 'Widget 反馈' }
};

/**
 * AI entityAction 刷新事件名：AIDrawer 派发，业务页监听后重新拉取数据。
 * event.detail: { entityType: string; entityId: string }
 */
export const AI_ENTITY_REFRESH = 'ai-entity-refresh';

export interface AIEntityRefreshDetail {
  entityType: string;
  entityId: string;
}

/** 浮窗不显示的路径（登录页、错误页） */
export const HIDE_PREFIXES = ['/smart/user'];
